import { Button, Typography } from '@breetometer/components';
import { CancelIcon, ChevronDown } from 'BreetAssets';
import { type MouseEvent, type RefObject, useCallback } from 'react';

import { DropdownWrapper } from '../Dropdown';
import type { ISelectInput, ISelectInputOption } from './SelectInput.helpers';

const SelectInput = ({ label, defaultOption, options, onChange, value, onClear }: ISelectInput) => {
	const selectValue = options?.find((i) => i.value && i.value === (value ?? defaultOption.value))?.label ?? defaultOption.label;

	const hasValue = value !== undefined && value !== '' && value !== defaultOption.value;

	const selectDropdownItem = useCallback(
		(item: ISelectInputOption, handleVisibility: () => void) => () => {
			onChange?.(item);
			handleVisibility();
		},
		[onChange]
	);

	const handleClear = useCallback(
		(event: MouseEvent<SVGSVGElement>) => {
			event.stopPropagation();
			onClear?.();
		},
		[onClear]
	);

	return (
		<div className='selectinput'>
			<DropdownWrapper>
				{({ buttonRef, controlRef, dropdownRef, dropdownStyles, handleVisibility, visible }) => (
					<div
						className='selectinput_buttonwrapper'
						ref={controlRef as RefObject<HTMLDivElement>}
					>
						<div className='selectinput_control'>
							{!!label && <label>{label}</label>}

							<div className='selectinput_field'>
								<Button
									variant='native'
									ref={buttonRef}
									onClick={handleVisibility}
								>
									{selectValue}
									<ChevronDown className={`selectinput_caret${visible ? ' open' : ''}`} />
								</Button>

								{!!onClear && hasValue && (
									<CancelIcon
										className='svg-dark svg-dark-outline svg-dark-fill-circle cursor_pointer selectinput_clear'
										variant='dropdown'
										focusable
										aria-label={`Clear ${label ?? 'selection'}`}
										onClick={handleClear}
									/>
								)}
							</div>
						</div>
						{visible && (
							<div
								className='ul-container dropdownshadow'
								ref={dropdownRef}
								style={dropdownStyles}
							>
								<Typography
									as='ul'
									className='scrollbar'
								>
									{options?.map((optionItem) => (
										<Typography
											as='li'
											key={optionItem.label}
										>
											<Button
												variant='native'
												onClick={selectDropdownItem(optionItem, handleVisibility)}
											>
												{optionItem.icon} {optionItem.label}
											</Button>
										</Typography>
									))}
								</Typography>
							</div>
						)}
					</div>
				)}
			</DropdownWrapper>
		</div>
	);
};

export default SelectInput;
